import type { ChapterParagraph } from '@/domains/proof-reading/types';

/**
 * 章节操作接口
 * @description 抽象章节相关操作，便于测试和解耦
 */
export interface ChapterOperations {
    /**
     * 根据段落索引获取段落信息
     * @param paragraphIndex 段落索引
     * @returns 段落信息或null
     */
    getCurrentParagraph(paragraphIndex: string): ChapterParagraph | null;

    /**
     * 更新段落内容
     * @param chapterId 章节ID
     * @param paragraphIndex 段落索引
     * @param newContent 新内容
     */
    updateParagraphContent(chapterId: string, paragraphIndex: string, newContent: string): void;
}

export const ChapterOperations = Symbol.for('ChapterOperations');
